// extracted by mini-css-extract-plugin
module.exports = {"sectionFeatures":"SectionFeatures_sectionFeatures_3Ad-I"};